export const phoneNumberFormat = '+000000000[000]';
export default {};
